import { render, staticRenderFns } from "./CardVideo.vue?vue&type=template&id=210e7fb6&scoped=true&"
import script from "./CardVideo.vue?vue&type=script&lang=js&"
export * from "./CardVideo.vue?vue&type=script&lang=js&"
import style0 from "./CardVideo.vue?vue&type=style&index=0&id=210e7fb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.7.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210e7fb6",
  null
  
)

export default component.exports